import "@firebase/auth";
import firebase from "./init";
export default firebase.auth();
